// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from 'flatbuffers';

import { ActionType } from '../tbs/action-type.js';


export class DeletePlayerAction implements flatbuffers.IUnpackableObject<DeletePlayerActionT> {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
  __init(i:number, bb:flatbuffers.ByteBuffer):DeletePlayerAction {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsDeletePlayerAction(bb:flatbuffers.ByteBuffer, obj?:DeletePlayerAction):DeletePlayerAction {
  return (obj || new DeletePlayerAction()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsDeletePlayerAction(bb:flatbuffers.ByteBuffer, obj?:DeletePlayerAction):DeletePlayerAction {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new DeletePlayerAction()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

type():ActionType {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.readUint16(this.bb_pos + offset) : ActionType.MapDeletePlayer;
}

playerId():number {
  const offset = this.bb!.__offset(this.bb_pos, 6);
  return offset ? this.bb!.readUint16(this.bb_pos + offset) : 0;
}

static startDeletePlayerAction(builder:flatbuffers.Builder) {
  builder.startObject(2);
}

static addType(builder:flatbuffers.Builder, type:ActionType) {
  builder.addFieldInt16(0, type, ActionType.MapDeletePlayer);
}

static addPlayerId(builder:flatbuffers.Builder, playerId:number) {
  builder.addFieldInt16(1, playerId, 0);
}

static endDeletePlayerAction(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  return offset;
}

static createDeletePlayerAction(builder:flatbuffers.Builder, type:ActionType, playerId:number):flatbuffers.Offset {
  DeletePlayerAction.startDeletePlayerAction(builder);
  DeletePlayerAction.addType(builder, type);
  DeletePlayerAction.addPlayerId(builder, playerId);
  return DeletePlayerAction.endDeletePlayerAction(builder);
}

unpack(): DeletePlayerActionT {
  return new DeletePlayerActionT(
    this.type(),
    this.playerId()
  );
}


unpackTo(_o: DeletePlayerActionT): void {
  _o.type = this.type();
  _o.playerId = this.playerId();
}
}

export class DeletePlayerActionT implements flatbuffers.IGeneratedObject {
constructor(
  public type: ActionType = ActionType.MapDeletePlayer,
  public playerId: number = 0
){}


pack(builder:flatbuffers.Builder): flatbuffers.Offset {
  return DeletePlayerAction.createDeletePlayerAction(builder,
    this.type,
    this.playerId
  );
}
}
